import styled from 'styled-components';

export const styledCalendarField = (Component) => styled(Component)`
  .field-container {
    > div {
      width: 136px;
    }

    svg {
      width: 16px;
      height: 16px;
      margin-bottom: 10px;

      path {
        fill: grey;
      }
    }
  }

  .DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside) {
    background-color: var(--primary500);
    color: white;
    border-radius: 0px;
  }

  .DayPicker-Day:not(.DayPicker-Day--disabled):not(.DayPicker-Day--selected):not(.DayPicker-Day--outside):hover {
    background-color: var(--primary100);
    border-radius: 0px;
    border: 1px solid var(--primary300);
  }
`;

export default styledCalendarField;
